import styled from "styled-components";
import {GameItemJackpotDefaultBox} from "./game-item-jackpot.default.box";

export const GameItemJackpotSICisBox = styled(GameItemJackpotDefaultBox)`
    width: 75%;
`;